import {SET_TOTALS, SET_TOTALS_EXTRAS} from "../constants/totalConstants";

export const setTotals = () => (dispatch, getState) => {
    const {transactions, rooms, parkFee, portFee, tax, activitiesOption, activities: {extra}} = getState();
    // Apply current state if no params are received
    let transactionList = transactions;
    try {
        // Overwrite transactions with sessionStorage if the user refreshes the page
        if (sessionStorage.getItem('transactions'))
            transactionList = JSON.parse(sessionStorage.getItem('transactions'));

        if (rooms.length === 0) throw new Error('There are no available rooms');

        const {selectedRooms, extra: selectedExtras, refundable} = transactionList;
        const roomsWithCost = _.cloneDeep(selectedRooms);
        let totalRefundable = 0;
        roomsWithCost.map(room => {
            let pretax = 'pretax';
            let single = 'single';
            if (refundable > 0) {
                pretax = 'refundable';
                single = 'singleRefundable';
            }
            const roomType = rooms.find(r => r.index === room.index);
            let costNode = room.singleOccupancy ? single : pretax;
            room['cost'] = roomType.price[costNode];

            pretax = 'refundable';
            single = 'singleRefundable';
            costNode = room.singleOccupancy ? single : pretax;
            room['costRefund'] = roomType.price[costNode];
        });

        // const companies = Object.keys(selectedExtras);
        // const extraActivities = extra.filter(e => extraIDs.includes((e.id).toString()));

        const roomsAmount = roomsWithCost.reduce((acc, cur) => acc + cur.cost, 0);
        const roomsAmountRefund = roomsWithCost.reduce((acc, cur) => acc + cur.costRefund, 0);


        // const multiplier = activitiesOption === 'all' ? selectedRooms.length : 1;
        // const activitiesAmount = extraActivities.reduce((acc, cur) => acc + cur.price, 0) * multiplier;
        const activitiesAmount = 0;
        // const subtotal = roomsAmount + activitiesAmount;

        let subtotal = roomsAmount;
        const taxes = roomsAmount * tax;
        const taxesRefund = roomsAmountRefund * tax;
        // const parkFeeCost = (parkFee?.perDay || 0) * (parkFee?.rewardDays || 0);
        const parkFeeCost = 0;
        const portFee = portFee?.feeAmount || 0;
        // const parkFeeTotal = parkFeeCost * roomsWithCost.length;
        const parkFeeTotal = 0;
        const total = subtotal + taxes + parkFeeTotal;
        //Refundable Total
        totalRefundable = roomsAmountRefund + taxesRefund + parkFeeTotal;

        dispatch({
            type: SET_TOTALS,
            payload: {
                portFee,
                parkFee: parkFeeTotal,
                parkFeeCost,
                activitiesAmount,
                roomsAmount,
                subtotal,
                taxes,
                total,
                totalRefundable
            }
        });

    } catch (e) {
        dispatch({
            type: SET_TOTALS,
            payload: {
                portFee: 0,
                parkFee: 0,
                parkFeeCost: 0,
                activitiesAmount: 0,
                roomsAmount: 0,
                subtotal: 0,
                taxes: 0,
                total: 0,
                totalRefundable: 0
            }
        });
    }
};
export const setTotalActivitiesFH = () => (dispatch, getState) => {
    const { transactions, activities } = getState();
    let transactionList = transactions;
    try {
        // Cargar desde sessionStorage si existe
        if (sessionStorage.getItem('transactions'))
            transactionList = JSON.parse(sessionStorage.getItem('transactions'));

        const { extra: selectedExtras } = transactionList;
        let activitiesAmount = 0;
        const items = [];

        if (activities.extra && Object.keys(activities.extra).length > 0) {
            Object.keys(selectedExtras).forEach(company => {
                Object.keys(selectedExtras[company]).forEach(activityId => {
                    const availabilities = selectedExtras[company][activityId];
                    // Soportar múltiples disponibilidades por actividad
                    Object.keys(availabilities).forEach(availabilityId => {
                        const availability = availabilities[availabilityId];

                        if (availability && availability.data && availability.data.customer_prototypes) {
                            const activityInfo = activities.extra.find(a => a.id === parseInt(activityId));
                            const pax = availability.pax || 0;
                            const otherCost = availability.data.customer_prototypes.total / 2000;
                            const subtotal = otherCost * pax;
                            activitiesAmount += subtotal;

                            items.push({
                                id: activityId,
                                company,
                                availabilityId,
                                date: availability.data.date,
                                activity: activityInfo?.name || 'Unknown',
                                pax,
                                cost: otherCost,
                                subtotal,
                            });
                        }
                    });
                });
            });
        }

        const tax = 0.16;
        const subtotal = activitiesAmount;
        const taxes = activitiesAmount * tax;
        const total = subtotal + taxes;

        dispatch({
            type: SET_TOTALS_EXTRAS,
            payload: {
                tax,
                activityItems: items,
                activitiesAmount,
                subtotal,
                taxes,
                total,
            }
        });

    } catch (e) {
        dispatch({
            type: SET_TOTALS_EXTRAS,
            payload: {
                activityItems: [],
                activitiesAmount: 0,
                subtotal: 0,
                tax: 0,
                taxes: 0,
                total: 0,
            }
        });
    }
};